module.exports = __webpack_public_path__ + "static/media/presentation.ce88c632.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/headers/presentation.jpg
// module id = 624
// module chunks = 11